<nav class="p-2 container">
<h1>Cocktails App</h1>
</nav>
<hr>

<style>
    .container{
        background-color: rgb(58, 58, 52);
        width: 100%;
        border-radius: 10px;
    }
    h1{
        text-align: center;
        color: burlywood;
    }
</style>